var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRepeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.236,11.928c-0.004,4.542-3.688,8.222-8.233,8.222c-1.496,0-2.899-0.396-4.107-1.094l1.606-1.58 c0.764,0.344,1.612,0.535,2.504,0.535c3.362,0,6.09-2.723,6.094-6.083h-3l4.113-4.006l4.112,4.006H20.236z M12.007,5.828 c-3.365,0-6.094,2.728-6.094,6.093c0,0.002,0,0.005,0,0.008h2.986l-2.484,2.418c0.003,0.006,0.005,0.012,0.008,0.018l-1.606,1.578 c-0.004-0.008-0.009-0.021-0.014-0.025l-0.018,0.018L0.671,11.93h3.096c0-0.004,0-0.007,0-0.011c0-4.548,3.687-8.235,8.235-8.235 c1.514,0,2.93,0.408,4.148,1.12L14.546,6.38C13.773,6.025,12.914,5.828,12.007,5.828z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRepeat);
export default __webpack_public_path__ + "static/media/ic_repeat.47a4b25779f21993f5d34d012733caeb.svg";
export { ForwardRef as ReactComponent };